module.exports = __webpack_public_path__ + "static/media/Spinner.c460795e.svg";